<template>
  <div class="demo">
    <div>
      普通select
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="large"
        size="large"
        appendToBody
      />
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="middle"
        size="middle"
        appendToBody
      />
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="default"
        size="default"
      />
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="small"
        size="small"
      />
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="mini"
        size="mini"
      />
    </div>
    <div>
      不同type
      <SjSelect
        class="select"
        v-model="selection"
        :options="options"
        placeholder="highlight"
      />
      <SjSelect
        class="select"
        v-model="selection"
        type="available"
        :options="options"
        placeholder="available"
      />
      <SjSelect
        class="select"
        v-model="selection"
        type="shadow"
        :options="options"
        placeholder="shadow"
      />
    </div>
    <div>
      分隔线
      <SjSelect
        class="select"
        v-model="selection"
        type="shadow"
        splitLine
        :options="options"
        placeholder="分隔线"
      />
    </div>
    <div>
      自定义下拉宽度
      <SjSelect
        class="select"
        v-model="selection"
        type="shadow"
        :dropdownWidth="250"
        :options="options"
        placeholder="自定义下拉宽度"
      />
    </div>
    <div>
      浅色字
      <SjSelect
        class="select"
        v-model="selection"
        type="shadow"
        colorNormal
        :options="options"
        placeholder="浅色字"
      />
    </div>
    <div>
      调整展示行数
      <SjSelect
        class="select"
        v-model="selection"
        :maxShowNumber="3"
        :options="options"
      />
    </div>
    <div>
      指定数据中的value-key
      <SjSelect
        class="select"
        value-key="b"
        v-model="selection"
        :options="optionsKey"
      />
    </div>
    <div>
      多选
      <SjSelect
        class="select"
        multiple
        v-model="selectionMulti"
        :options="options"
      />
    </div>
    <div>
      含有分类标签和分割线示例
      <SjSelect
        class="select"
        multiple
        v-model="selection3"
        :options="options2"
      />
    </div>
    <div>
      搜索过滤
      <SjSelect
        class="select"
        filterable
        :filterMethod="filterMethod"
        @inputEnter="handleEnter"
        v-model="selection"
        :options="options"
      />
    </div>
    <div>
      单选可清空
      <SjSelect
        class="select"
        clearable
        v-model="selection"
        :options="options"
      />
    </div>
    <div>
      包含tooltips
      <SjSelect class="select" v-model="selection4" :options="options3" />
    </div>
    <div>
      多层Select
      <SjSelect class="select" v-model="selection5" :options="options4" />
    </div>
    <div>
      自定义多层区域
      <SjSelect class="select" v-model="selection" :options="options5">
        <div @click.stop slot-scope="{ data }">{{ data.label }}</div>
      </SjSelect>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          label: "test1",
          value: 1,
          num: 999
        },
        {
          label: "test2",
          value: 2,
          disabled: true
        },
        {
          label: "test3",
          value: 3
        },
        {
          label: "test4",
          value: 4
        },
        {
          label: "test5",
          value: 5
        },
        {
          label: "test6",
          value: 6
        },
        {
          label: "test7",
          value: 7
        },
        {
          label: "test8",
          value: 8
        }
      ],
      optionsKey: [
        {
          label: "test1",
          value: { a: 1, b: 4 }
        },
        {
          label: "test2",
          value: { a: 2, b: 3 }
        },
        {
          label: "test3",
          value: { a: 3, b: 2 }
        },
        {
          label: "test4",
          value: { a: 4, b: 1 }
        }
      ],
      options2: [
        {
          label: "testq",
          value: "q"
        },
        {
          label: "category1",
          options: [
            {
              label: "test1",
              value: 1
            },
            {
              label: "test2",
              value: 2
            }
          ]
        },
        {
          label: "category2",
          options: [
            {
              label: "test3",
              value: 3
            },
            {
              label: "test4",
              value: 4
            }
          ]
        }
      ],
      options3: [
        {
          label: "test1",
          value: 1,
          tooltips: "tooltips8888888",
          tipIcon: "icon_ry RYlock"
        },
        {
          label: "test2",
          value: 2
        },
        {
          label: "test3",
          value: 3
        },
        {
          label: "test4",
          value: 4,
          tooltips: "tooltipstooltipstooltipstooltipstooltips"
        }
      ],
      selection: null,
      selection4: null,
      selectionMulti: [],
      selection5: null,
      options4: [
        {
          label: "test1",
          value: 1,
          children: [
            {
              label: "test2",
              value: 2
            },
            {
              label: "test3",
              value: 3
            }
          ]
        },
        {
          label: "test4",
          value: 4,
          children: [
            {
              label: "test2",
              value: 2
            },
            {
              label: "test3",
              value: 3
            }
          ]
        }
      ],
      selection3: [],
      options5: [
        {
          label: "test1",
          value: 1
        },
        {
          label: "test2",
          value: 2
        },
        {
          label: "test3",
          value: 3,
          multiExpand: true
        }
      ]
    };
  },
  methods: {
    filterMethod(text, dataItem) {
      console.log(text, dataItem);
      return Math.random() > 0.5;
    },
    handleEnter(e) {
      console.log(e.target.value);
    }
  }
};
</script>

<style scoped lang="less">
.demo {
  > * {
    display: flex;
    align-items: center;

    + * {
      margin-top: 20px;
      .select {
        margin-left: 20px;
        width: 180px;

        .select_item {
          flex: 1;
        }
      }
    }
  }
}
</style>
